<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';
import excel from 'vue-excel-export';
Vue.use(excel)
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Structure",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Structure",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "course",
          label: "Course",
          sortable: true,
        },
        {
          key: "level",
          label: "Level",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
      ],
      data: {
        year: new Date().getFullYear(),
      },
      years: [
        { name: new Date().getFullYear() },
        { name: new Date().getFullYear() - 1 },
        { name: new Date().getFullYear() - 2 },
      ],
      yearError: "",
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesStructure", "SaveStatus"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesStructure ? this.FeesStructure.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesStructure ? this.FeesStructure.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStructure: "fees/fetchFeesStructure",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesStructure ? this.FeesStructure.length : 1;
      this.currentPage = 1;
    },
    resetError() {
      this.yearError = "";
    },

    Fetch_Structure() {
      if (this.data.year == "") {
        this.yearError = "Please select a year";
        return;
      } else {
        this.yearError = "";
      }
      this.FetchStructure(this.data);
    },
  },
  created() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="col-form-label">
                    Year <span class="required">*</span></label
                  >
                  <select
                    :class="{ 'form-control': true }"
                    v-model="data.year"
                    name="year"
                  >
                    <option v-for="year in years" :key="year.name">
                      {{ year.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3 mt-3">
                <br />
                <button
                  @click="Fetch_Structure()"
                  class="btn btn-outline-primary"
                >
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
              <div class="col-md-6" align="right">
                <export-excel
                      :data   = "FeesStructure"
                      name    = "Fees Structure.xls">
                      <b-btn variant="success">
                      <i class="fa fa-download"></i>
                      Excel
                      </b-btn>
                  </export-excel>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FeesStructure ? FeesStructure : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
